
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11686',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11686",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.451",
  "dashboard-client-types": "static-1.263",
  "data-fetching-client": "static-1.9521",
  "foundations-components": "static-1.7609",
  "foundations-components-legacy": "static-1.634",
  "foundations-theming": "static-1.4255",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7850",
  "hub-http-shared-msw-handlers": "static-1.9575",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11284",
  "I18n": "static-7.1583",
  "jasmine-runner": "static-1.6313",
  "marketplace-storefront-base": "static-1.11746",
  "quartz": "static-1.6791",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16493",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2707",
  "reporting-testing-lib": "static-1.8642",
  "settings-ui-lib": "static-1.12366",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6814",
  "ui-addon-i18n": "static-1.10988",
  "ui-addon-react-router-dom": "static-1.9388",
  "unified-auth": "static-1.275",
  "unified-auth-core-lib": "static-1.556",
  "usage-tracker": "static-1.7178",
  "usage-tracker-core": "static-1.7028",
  "customer-data-property-utils": "static-1.7922",
  "history": "static-4.47",
  "hub-http": "static-1.6060",
  "integrations-lib": "static-1.15563",
  "marketplace-ui-common": "static-1.19067",
  "property-management-iframe": "static-1.12516",
  "quartz-config": "static-1.569",
  "quartz-core": "static-1.6010",
  "quartz-routing": "static-1.221",
  "quick-fetch": "static-1.3780",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4481",
  "ts-schema": "static-1.3946",
  "ui-universal-auth": "static-1.8761",
  "UIComponents": "static-3.8231",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3270",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3068",
  "quartz-webpack": "static-1.3015",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3878",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4682",
  "foundations-theming-specialty": "static-1.1971",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9269",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5216",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1334",
  "ui-fonts": "static-1.546",
  "ui-images": "static-2.1109",
  "bend-plugin-foundations-theming": "static-1.2738",
  "foundations-theming-base": "static-1.3240",
  "stylex": "static-1.28",
  "HeadJS": "static-2.721",
  "hs-test-utils-bend-plugin": "static-1.2961",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4169",
  "ai-components-ui-library": "static-1.8469",
  "ai-rendering-library": "static-1.9435",
  "chirp-fetch": "static-1.1727",
  "connections-embed-lib": "static-1.698",
  "copilot-toolkit": "static-1.10641",
  "laboratory-lib": "static-3.7003",
  "marketplace-embed": "static-1.21585",
  "marketplace-ui-details": "static-1.8963",
  "marketplace-ui-reviews": "static-1.19023",
  "marketplace-ui-tracking": "static-1.13238",
  "sanitize-text": "static-1.7989",
  "ui-addon-video-player": "static-1.8540",
  "usage-tracker-multi": "static-1.5592",
  "usage-tracker-session-replay": "static-1.4864",
  "wootric-nps": "static-1.6826",
  "apollo-link-hub-http": "static-2.4494",
  "immer": "static-1.33",
  "immerable": "static-1.3997",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2389",
  "reporting-data": "static-1.66709",
  "cssUtils": "static-1.748",
  "flux-actions": "static-1.314",
  "HubStyle": "static-2.11592",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10054",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10217",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7168",
  "icons": "static-2.629",
  "marketplace-ui-apps-core": "static-1.17600",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4363",
  "foundations-components-test-utils": "static-1.5092",
  "quartz-i18n": "static-1.466",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3573",
  "customer-data-objects": "static-1.7494",
  "property-translator": "static-1.5253",
  "frontend-preferences-client": "static-1.7767",
  "hs-promise-utils": "static-1.5437",
  "hubspot-apollo-client": "static-1.4723",
  "integrations-error-boundary-lib": "static-1.12978",
  "integrations-tracking-lib": "static-1.5433",
  "native-integrations-shared-strings": "static-1.7631",
  "reselect": "static-2.16",
  "sanitize": "static-1.4318",
  "superstore": "static-1.4613",
  "ui-shepherd-react": "static-3.9989",
  "ai-settings-ui-library": "static-1.7583",
  "hub-http-janus": "static-1.806",
  "hubspotter-http": "static-1.4519",
  "immutable-less": "static-1.4498",
  "marketplace-ui-client-types": "static-1.16474",
  "nav-meta": "static-1.29052",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10085",
  "ui-addon-upgrades": "static-9.17717",
  "inbound-db-properties-service-client": "static-1.3713",
  "property-management-common": "static-1.4803",
  "ui-addon-iframeable": "static-1.8891",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.496",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.466",
  "quartz-head": "static-1.456",
  "quartz-test": "static-1.466",
  "quartz-tracking": "static-1.170",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2992",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20501",
  "ContentUtils": "static-1.67750",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2334",
  "customer-data-filters-ui": "static-1.39056",
  "customer-data-objects-ui-components": "static-1.12855",
  "customer-data-reference-ui-components": "static-1.12991",
  "embedded-academy-lib": "static-1.13706",
  "ExportDialog": "static-6.10231",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40764",
  "reporting-snowflake": "static-1.55327",
  "reporting-ui-components": "static-2.63980",
  "reporting-visualizations": "static-1.58785",
  "ui-addon-teams": "static-1.21299",
  "magpie-lib": "static-1.5437",
  "magpie-types": "static-1.4897",
  "simple-logging-lib": "static-1.2894",
  "navigation-components": "static-1.17415",
  "ai-studio-lib": "static-1.11111",
  "developer-experience-shared-components": "static-1.10341",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7836",
  "ui-tool-access": "static-1.9988",
  "usage-based-billing-components-lib": "static-1.8127",
  "usage-tracker-anonymous": "static-1.5595",
  "usage-tracker-public": "static-1.6989",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3462",
  "persist-promise": "static-1.3552",
  "reference-resolvers": "static-1.8005",
  "ui-extensibility-client-types": "static-1.3787",
  "hubspot-apollo-cache": "static-1.182",
  "universal-page-editor-lib": "static-1.2844",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2299",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4914",
  "purchase-motions-components": "static-1.5536",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1395",
  "crm-component-utils": "static-1.38583",
  "crm-properties-common-lib": "static-1.5716",
  "customer-data-properties": "static-1.50894",
  "framework-data-schema-resolvers": "static-1.6717",
  "property-value-citations": "static-1.1508",
  "reference-resolvers-lite": "static-1.7926",
  "navigation-messaging": "static-1.6742",
  "hubspotter-http-shared-msw-handlers": "static-1.9573",
  "cms-field-types": "static-1.4651",
  "content-icons-ui": "static-1.2172",
  "conversations-skeleton-state": "static-1.7091",
  "crm-message-bus": "static-1.42491",
  "customer-data-filters-ui-msw-helpers": "static-1.21491",
  "customer-data-ui-utilities": "static-1.9667",
  "FormUrlGenerator": "static-2.4564",
  "framework-builder-read-service-client": "static-1.3874",
  "framework-data-schema-quick-fetch": "static-1.6622",
  "multi-account-reference-resolvers": "static-1.818",
  "onboarding-tours": "static-1.16324",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13183",
  "academy-common-lib": "static-1.13166",
  "content-assistance-lib": "static-1.7510",
  "dashboard-lib": "static-1.80805",
  "file-manager-components": "static-1.23027",
  "getting-started-shared-tasks": "static-1.18001",
  "hubspot-prosemirror": "static-1.17720",
  "hubspot-prosemirror-plugins": "static-1.17712",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19542",
  "share-with-third-party-component-lib": "static-1.8536",
  "ui-addon-draggable": "static-3.4611",
  "ui-asset-management-lib": "static-1.10766",
  "ui-business-units-lib": "static-1.8874",
  "user-context": "static-1.4944",
  "growth-payments-core": "static-1.24848",
  "reporting-plugins": "static-1.10031",
  "reporting-reports": "static-1.66387",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.569",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28950",
  "react-codemirror": "static-1.10469",
  "apps-service-types": "static-1.3721",
  "oauth-service-types": "static-1.4091",
  "onboarding-scopes": "static-1.6306",
  "onboarding-tours-client": "static-1.4538",
  "platform-infra-nav-components": "static-1.7533",
  "subscription-experience-data-types": "static-1.14636",
  "crm-record-cards-service-types": "static-1.3483",
  "location-customization-utils-lib": "static-1.8695",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4343",
  "nav-client-types": "static-1.2201",
  "purchase-motions-api": "static-1.5539",
  "signup-constants": "static-1.18505",
  "signup-ui-url-generator": "static-2.7878",
  "trials-service-types": "static-1.3744",
  "card-properties-lib": "static-1.43646",
  "commerce-subscription-lib": "static-1.36581",
  "crm-actions": "static-1.6149",
  "crm-cards-sdk": "static-1.43049",
  "customer-data-properties-shared-msw-handlers": "static-1.8902",
  "customer-data-tracking": "static-1.6725",
  "hs-entities": "static-1.525",
  "pulse": "static-1.360",
  "calling-global-api": "static-1.63826",
  "calling-internal-common": "static-1.31141",
  "calling-lifecycle-internal": "static-1.65208",
  "calling-lifecycle-messages": "static-1.57502",
  "commerce-products-lib": "static-1.8971",
  "conditional-properties-service-client": "static-1.3664",
  "crm-links": "static-1.6110",
  "external-options-client-types": "static-1.4026",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4090",
  "meetings-icalendar-utils-lib": "static-1.475",
  "multi-currency-client-types": "static-1.3557",
  "object-builder-ui-client": "static-1.48142",
  "pipeline-validation-client-types": "static-1.3830",
  "smart-property-lib": "static-1.6104",
  "tiered-pricing": "static-1.892",
  "ui-addon-form-validation": "static-1.10837",
  "crm-pipelines-api-client-types": "static-1.4007",
  "react-dnd-compat": "static-1.4464",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5202",
  "growth-onboarding-confetti": "static-1.2916",
  "growth-onboarding-next-action-utils": "static-1.1407",
  "onboarding-tours-utils": "static-1.390",
  "ui-shepherd-tracker": "static-1.7370",
  "academy-service-client": "static-1.3524",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28056",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8228",
  "video-components-external": "static-1.10692",
  "video-data-lib": "static-1.34350",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23053",
  "ui-addon-emoji-picker": "static-1.9731",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6881",
  "data-token-picker": "static-1.16115",
  "FileManagerLib": "static-1.38667",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5087",
  "getting-started-shared-tasks-store": "static-1.17119",
  "campaign-roi-lib": "static-1.8413",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.235",
  "eligibility-engine-service-types": "static-1.3025",
  "crm_data": "static-4.91386",
  "customer-data-sidebar": "static-2.45530",
  "enrichment-properties-lib": "static-1.15222",
  "commerce-billing-lib": "static-1.18610",
  "commerce-shared-components-lib": "static-1.18060",
  "commerce-tools-ui-lib": "static-1.9901",
  "crm-fe-perf": "static-1.22749",
  "directed-graph": "static-1.782",
  "event-emitter": "static-1.791",
  "calling-error-reporting": "static-1.31147",
  "shared-worker-versioning": "static-1.10882",
  "calling-usage-tracker": "static-1.6385",
  "voice-sms-access-library": "static-1.370",
  "commerce-permissions": "static-1.604",
  "products-iframe-lib": "static-1.7443",
  "products-ui-components-shared-msw-handlers": "static-1.9957",
  "breeze-intelligence-kit": "static-1.5384",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9658",
  "policy-lib": "static-1.6621",
  "react-tinymce": "static-1.54739",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9721",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53865",
  "tinymce-plugins": "static-1.56979",
  "tinymce-themes": "static-1.55835",
  "growth-onboarding-next-action-components": "static-1.1435",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6425",
  "content-media-composition-data-lib": "static-1.11600",
  "content-media-compositions": "static-2.15607",
  "media-bridge-lib": "static-1.18636",
  "commerce-tours-lib": "static-1.5782",
  "growth-onboarding-reliability": "static-1.4930",
  "sales-checkout-service-client": "static-1.3510",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21380",
  "sales-email-signature-service-client": "static-1.3687",
  "audio-components": "static-1.5674",
  "FileManagerCore": "static-1.38526",
  "FileManagerImages": "static-1.36178",
  "video-components": "static-1.12695",
  "crm_universal": "static-1.21731",
  "customer-data-email": "static-1.17741",
  "card-payment-highlight-lib": "static-1.36633",
  "card-subscription-highlight-lib": "static-1.39004",
  "commerce-contract-lib": "static-1.11353",
  "customer-data-content": "static-1.26949",
  "invoices-highlight-card-lib": "static-1.54168",
  "orders-highlight-card-lib": "static-1.20974",
  "products-highlight-card-lib": "static-1.17255",
  "project-storage": "static-1.4577",
  "quotes-highlight-card-lib": "static-1.71343",
  "crm-source-interpretation-lib": "static-1.5174",
  "utility-belt": "static-1.2383",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11516",
  "payments-enrollment-embed-lib": "static-1.22137",
  "customer-data-rte": "static-1.32548",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5430",
  "InboxConnectUtils": "static-4.14332",
  "payments-post-enroll-local-storage-lib": "static-1.4957",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37432",
  "calling-orchestration-schema": "static-1.35147",
  "sales-views-client-types": "static-1.4130",
  "hub-http-contrib": "static-1.2887",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39950",
  "ui-addon-sales-email": "static-1.5057",
  "layout-dnd-components": "static-1.12119",
  "layout-dnd-utils": "static-1.11094",
  "ui-brand-identity-lib": "static-1.14187",
  "NamespacedHubStyle": "static-2.8937",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4374",
  "video-embed": "static-1.35184",
  "social-insights-client-types": "static-1.21483",
  "sequences-lib": "static-1.7753",
  "ui-gdpr-components": "static-1.10191",
  "products-ui-components": "static-1.39490",
  "quotes-ui-lib": "static-1.80063",
  "SalesContentIndexUI": "static-3.8966",
  "accounting-integrations-ui-components": "static-1.6794",
  "invoices-ui-lib": "static-1.54184",
  "commerce-products-api": "static-1.2020",
  "SafeStorage": "static-1.4245",
  "invoices-iframe-lib": "static-1.56242",
  "quotes-modal-lib": "static-1.102020",
  "deal-intel-decorators": "static-1.1416",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7208",
  "draft-content-plugins": "static-1.27815",
  "ContentData": "static-1.67825",
  "layout-data-lib": "static-1.9419",
  "outpost": "static-1.4044",
  "sequences-client-types-lib": "static-1.7610",
  "commerce-tax-lib": "static-1.360",
  "property-description-translator": "static-1.3700",
  "FireAlarmUi": "static-1.4374",
  "sales-templates-service-types-lib": "static-1.4033",
  "commerce-analytics-service-client": "static-1.3498",
  "totals-ui-components": "static-1.23103",
  "deal-intel-utils": "static-1.1420",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14880",
  "advanced-menus-lib": "static-1.11850",
  "ui-memberships-settings-lib": "static-1.33564",
  "commerce-totals-service-types": "static-1.3682",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14879",
  "simple-menus-lib": "static-1.16396"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11686",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.451",
  "dashboard-client-types": "/dashboard-client-types/static-1.263",
  "data-fetching-client": "/data-fetching-client/static-1.9521",
  "foundations-components": "/foundations-components/static-1.7609",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.634",
  "foundations-theming": "/foundations-theming/static-1.4255",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7850",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9575",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11284",
  "I18n": "/I18n/static-7.1583",
  "jasmine-runner": "/jasmine-runner/static-1.6313",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11746",
  "quartz": "/quartz/static-1.6791",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16493",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2707",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8642",
  "settings-ui-lib": "/settings-ui-lib/static-1.12366",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6814",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10988",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9388",
  "unified-auth": "/unified-auth/static-1.275",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.556",
  "usage-tracker": "/usage-tracker/static-1.7178",
  "usage-tracker-core": "/usage-tracker-core/static-1.7028",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7922",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6060",
  "integrations-lib": "/integrations-lib/static-1.15563",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19067",
  "property-management-iframe": "/property-management-iframe/static-1.12516",
  "quartz-config": "/quartz-config/static-1.569",
  "quartz-core": "/quartz-core/static-1.6010",
  "quartz-routing": "/quartz-routing/static-1.221",
  "quick-fetch": "/quick-fetch/static-1.3780",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4481",
  "ts-schema": "/ts-schema/static-1.3946",
  "ui-universal-auth": "/ui-universal-auth/static-1.8761",
  "UIComponents": "/UIComponents/static-3.8231",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3270",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3068",
  "quartz-webpack": "/quartz-webpack/static-1.3015",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3878",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4682",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1971",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9269",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5216",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1334",
  "ui-fonts": "/ui-fonts/static-1.546",
  "ui-images": "/ui-images/static-2.1109",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2738",
  "foundations-theming-base": "/foundations-theming-base/static-1.3240",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.721",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2961",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4169",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8469",
  "ai-rendering-library": "/ai-rendering-library/static-1.9435",
  "chirp-fetch": "/chirp-fetch/static-1.1727",
  "connections-embed-lib": "/connections-embed-lib/static-1.698",
  "copilot-toolkit": "/copilot-toolkit/static-1.10641",
  "laboratory-lib": "/laboratory-lib/static-3.7003",
  "marketplace-embed": "/marketplace-embed/static-1.21585",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8963",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19023",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13238",
  "sanitize-text": "/sanitize-text/static-1.7989",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8540",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5592",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4864",
  "wootric-nps": "/wootric-nps/static-1.6826",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4494",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3997",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2389",
  "reporting-data": "/reporting-data/static-1.66709",
  "cssUtils": "/cssUtils/static-1.748",
  "flux-actions": "/flux-actions/static-1.314",
  "HubStyle": "/HubStyle/static-2.11592",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10054",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10217",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7168",
  "icons": "/icons/static-2.629",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17600",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4363",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5092",
  "quartz-i18n": "/quartz-i18n/static-1.466",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3573",
  "customer-data-objects": "/customer-data-objects/static-1.7494",
  "property-translator": "/property-translator/static-1.5253",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7767",
  "hs-promise-utils": "/hs-promise-utils/static-1.5437",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4723",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12978",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5433",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7631",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4318",
  "superstore": "/superstore/static-1.4613",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9989",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7583",
  "hub-http-janus": "/hub-http-janus/static-1.806",
  "hubspotter-http": "/hubspotter-http/static-1.4519",
  "immutable-less": "/immutable-less/static-1.4498",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16474",
  "nav-meta": "/nav-meta/static-1.29052",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10085",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17717",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3713",
  "property-management-common": "/property-management-common/static-1.4803",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8891",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.496",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.466",
  "quartz-head": "/quartz-head/static-1.456",
  "quartz-test": "/quartz-test/static-1.466",
  "quartz-tracking": "/quartz-tracking/static-1.170",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20501",
  "ContentUtils": "/ContentUtils/static-1.67750",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2334",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39056",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12855",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12991",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13706",
  "ExportDialog": "/ExportDialog/static-6.10231",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40764",
  "reporting-snowflake": "/reporting-snowflake/static-1.55327",
  "reporting-ui-components": "/reporting-ui-components/static-2.63980",
  "reporting-visualizations": "/reporting-visualizations/static-1.58785",
  "ui-addon-teams": "/ui-addon-teams/static-1.21299",
  "magpie-lib": "/magpie-lib/static-1.5437",
  "magpie-types": "/magpie-types/static-1.4897",
  "simple-logging-lib": "/simple-logging-lib/static-1.2894",
  "navigation-components": "/navigation-components/static-1.17415",
  "ai-studio-lib": "/ai-studio-lib/static-1.11111",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10341",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7836",
  "ui-tool-access": "/ui-tool-access/static-1.9988",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8127",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5595",
  "usage-tracker-public": "/usage-tracker-public/static-1.6989",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3462",
  "persist-promise": "/persist-promise/static-1.3552",
  "reference-resolvers": "/reference-resolvers/static-1.8005",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3787",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.182",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2844",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2299",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4914",
  "purchase-motions-components": "/purchase-motions-components/static-1.5536",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1395",
  "crm-component-utils": "/crm-component-utils/static-1.38583",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5716",
  "customer-data-properties": "/customer-data-properties/static-1.50894",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6717",
  "property-value-citations": "/property-value-citations/static-1.1508",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7926",
  "navigation-messaging": "/navigation-messaging/static-1.6742",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9573",
  "cms-field-types": "/cms-field-types/static-1.4651",
  "content-icons-ui": "/content-icons-ui/static-1.2172",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7091",
  "crm-message-bus": "/crm-message-bus/static-1.42491",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21491",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9667",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4564",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3874",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6622",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.818",
  "onboarding-tours": "/onboarding-tours/static-1.16324",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13183",
  "academy-common-lib": "/academy-common-lib/static-1.13166",
  "content-assistance-lib": "/content-assistance-lib/static-1.7510",
  "dashboard-lib": "/dashboard-lib/static-1.80805",
  "file-manager-components": "/file-manager-components/static-1.23027",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18001",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17720",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17712",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19542",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8536",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4611",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10766",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8874",
  "user-context": "/user-context/static-1.4944",
  "growth-payments-core": "/growth-payments-core/static-1.24848",
  "reporting-plugins": "/reporting-plugins/static-1.10031",
  "reporting-reports": "/reporting-reports/static-1.66387",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.569",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28950",
  "react-codemirror": "/react-codemirror/static-1.10469",
  "apps-service-types": "/apps-service-types/static-1.3721",
  "oauth-service-types": "/oauth-service-types/static-1.4091",
  "onboarding-scopes": "/onboarding-scopes/static-1.6306",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4538",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7533",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14636",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3483",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8695",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4343",
  "nav-client-types": "/nav-client-types/static-1.2201",
  "purchase-motions-api": "/purchase-motions-api/static-1.5539",
  "signup-constants": "/signup-constants/static-1.18505",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7878",
  "trials-service-types": "/trials-service-types/static-1.3744",
  "card-properties-lib": "/card-properties-lib/static-1.43646",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36581",
  "crm-actions": "/crm-actions/static-1.6149",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43049",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8902",
  "customer-data-tracking": "/customer-data-tracking/static-1.6725",
  "hs-entities": "/hs-entities/static-1.525",
  "pulse": "/pulse/static-1.360",
  "calling-global-api": "/calling-global-api/static-1.63826",
  "calling-internal-common": "/calling-internal-common/static-1.31141",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65208",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57502",
  "commerce-products-lib": "/commerce-products-lib/static-1.8971",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3664",
  "crm-links": "/crm-links/static-1.6110",
  "external-options-client-types": "/external-options-client-types/static-1.4026",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4090",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.475",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3557",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48142",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3830",
  "smart-property-lib": "/smart-property-lib/static-1.6104",
  "tiered-pricing": "/tiered-pricing/static-1.892",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10837",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4007",
  "react-dnd-compat": "/react-dnd-compat/static-1.4464",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5202",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2916",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1407",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.390",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7370",
  "academy-service-client": "/academy-service-client/static-1.3524",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28056",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8228",
  "video-components-external": "/video-components-external/static-1.10692",
  "video-data-lib": "/video-data-lib/static-1.34350",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23053",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9731",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6881",
  "data-token-picker": "/data-token-picker/static-1.16115",
  "FileManagerLib": "/FileManagerLib/static-1.38667",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5087",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17119",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8413",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.235",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3025",
  "crm_data": "/crm_data/static-4.91386",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45530",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15222",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18610",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18060",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9901",
  "crm-fe-perf": "/crm-fe-perf/static-1.22749",
  "directed-graph": "/directed-graph/static-1.782",
  "event-emitter": "/event-emitter/static-1.791",
  "calling-error-reporting": "/calling-error-reporting/static-1.31147",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10882",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6385",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.370",
  "commerce-permissions": "/commerce-permissions/static-1.604",
  "products-iframe-lib": "/products-iframe-lib/static-1.7443",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9957",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5384",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9658",
  "policy-lib": "/policy-lib/static-1.6621",
  "react-tinymce": "/react-tinymce/static-1.54739",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9721",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53865",
  "tinymce-plugins": "/tinymce-plugins/static-1.56979",
  "tinymce-themes": "/tinymce-themes/static-1.55835",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1435",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6425",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11600",
  "content-media-compositions": "/content-media-compositions/static-2.15607",
  "media-bridge-lib": "/media-bridge-lib/static-1.18636",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5782",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4930",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3510",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21380",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3687",
  "audio-components": "/audio-components/static-1.5674",
  "FileManagerCore": "/FileManagerCore/static-1.38526",
  "FileManagerImages": "/FileManagerImages/static-1.36178",
  "video-components": "/video-components/static-1.12695",
  "crm_universal": "/crm_universal/static-1.21731",
  "customer-data-email": "/customer-data-email/static-1.17741",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36633",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39004",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11353",
  "customer-data-content": "/customer-data-content/static-1.26949",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54168",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20974",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17255",
  "project-storage": "/project-storage/static-1.4577",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71343",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5174",
  "utility-belt": "/utility-belt/static-1.2383",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11516",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22137",
  "customer-data-rte": "/customer-data-rte/static-1.32548",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5430",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14332",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4957",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37432",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35147",
  "sales-views-client-types": "/sales-views-client-types/static-1.4130",
  "hub-http-contrib": "/hub-http-contrib/static-1.2887",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39950",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5057",
  "layout-dnd-components": "/layout-dnd-components/static-1.12119",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11094",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14187",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8937",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4374",
  "video-embed": "/video-embed/static-1.35184",
  "social-insights-client-types": "/social-insights-client-types/static-1.21483",
  "sequences-lib": "/sequences-lib/static-1.7753",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10191",
  "products-ui-components": "/products-ui-components/static-1.39490",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80063",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8966",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6794",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54184",
  "commerce-products-api": "/commerce-products-api/static-1.2020",
  "SafeStorage": "/SafeStorage/static-1.4245",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56242",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102020",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1416",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7208",
  "draft-content-plugins": "/draft-content-plugins/static-1.27815",
  "ContentData": "/ContentData/static-1.67825",
  "layout-data-lib": "/layout-data-lib/static-1.9419",
  "outpost": "/outpost/static-1.4044",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7610",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.360",
  "property-description-translator": "/property-description-translator/static-1.3700",
  "FireAlarmUi": "/FireAlarmUi/static-1.4374",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4033",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3498",
  "totals-ui-components": "/totals-ui-components/static-1.23103",
  "deal-intel-utils": "/deal-intel-utils/static-1.1420",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14880",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11850",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33564",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3682",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14879",
  "simple-menus-lib": "/simple-menus-lib/static-1.16396"
}
};
